import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { SpsFocusedTaskComponent, SpsFocusedTaskActionsComponent } from "../components/index";
import { SpsDSCoreModule } from "./sps-ds-core.module";

@NgModule({
    imports: [CommonModule, SpsDSCoreModule],
    declarations: [
        SpsFocusedTaskComponent,
        SpsFocusedTaskActionsComponent,
    ],
    exports: [
        SpsFocusedTaskComponent,
        SpsFocusedTaskActionsComponent,
    ],
})
export class SpsFocusedTaskModule {}
